import { OutlinedButton } from "@components/atoms/base-button";
import { translate } from "@locales";
import { truncateText } from "@models/interactions/truncate-text";
import { useFormat } from "@models/interactions/use-format";
import { Link } from "@shopify/hydrogen";

export function FeatuerdArticle({ blog }) {
  return (
    <div className="flex flex-col md:justify-center lg:flex-row lg:flex-wrap lg:mx-32 lg:mt-[45px]">

    <div className="w-full flex items-center justify-center">
      <div className="flex justify-center max-sm:flex-col lg:flex-row-reverse lg:mx-0 max-sm:mx-5 lg:mt-[45px] max-sm:mt-6 lg:mb-[55px] sm:mb-[35px] lg:h-[390px] h-[488px]">
        <img
          src={blog.image.url ?? "/static/img/BlogCover.png"}
          alt="Blog Cover Image"
          className="sm:w-full lg:w-[784px] lg:h-[390px] h-[201px] lg:pb-0 sm:pb-4 object-cover"
        />
        <div className=" lg:h-[346px] lg:w-1/3 lg:ml-[35px] lg:mr-[42px] lg:my-[22px] sm:h-[182px] max-sm:pb-10  max-sm:px-[11px]">
          <div className="w-5 h-5">
            <img src="//cdn.shopify.com/s/files/1/0044/3708/2200/t/82/assets/star_icon.svg?v=35993646835444440671681391061" />
          </div>
          <span className="font-chivo-regular lg:text-xs max-sm:text-[10px] text-custom-gray text-left lg:pb-3 sm:pb-[9px]">
            {useFormat(blog.publishedAt)}
          </span>
          <h2 className="max-sm:text-lg22 lg:text-[25px] text-left font-chivo-italic pb-2.5">
            {blog.title}
          </h2>
          <div className="flex space-x-2 pb-3">
            {blog.tags.map((tag) => {
              return (
                <div className="w-auto h-5 text-white bg-dark-gray rounded-sm ">
                  <p className="font-chivo-regular text-[10px] uppercase m-1">
                    #{tag}
                  </p>
                </div>
              );
            })}
          </div>
          <p className="font-chivo-light lg:text-xs max-sm:text-[10px] lg:pb-5 max-sm:pb-4">
            {truncateText(blog.content, 150)}
          </p>
          <Link to={`/blogs/educational/${blog.handle}`}>
            <OutlinedButton className="max-sm:w-full text-sm lg:w-[218px] h-[55px] hover:bg-black hover:text-white">
              {translate("base.read-more")}
            </OutlinedButton>
          </Link>
        </div>
      </div>
      </div>
      </div>
    );
}
